import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from '../core/base/base.service';
import { RestService } from '../core/service/rest.service';
import { Utils } from '../core/utils/khuyana.utils';
import { AdminCatalogModel } from '../model/admin/catalog';
import { CommonTurnViewModel } from '../model/common/turn.view';
import { SecurityUserLoginModel } from '../model/security/security-user.login';
import { adminUserActions } from '../store/admin/user/admin-user.action';
import { commonTurnActions } from '../store/common/turn/turn.action';
import { AdminSubCatalogService } from './admin/subcatalog/admin-subcatalog.service';

@Injectable({
  providedIn: 'root',
})
export class MainService extends BaseService {
  constructor(
    override store: Store<any>,
    protected rest: RestService,
    protected catalogService: AdminSubCatalogService
  ) {
    super();
  }

  getTurnsId = (): Observable<number[]> =>
    this.store.select('common', 'turn', 'turnsId');

  getTurnPatientQuery = (): Observable<string> =>
    this.store.select('common', 'turn', 'patientQuery');

  getTurnDoctorQuery = (): Observable<string> =>
    this.store.select('common', 'turn', 'doctorQuery');

  getTurnSpecialtyQuery = (): Observable<string> =>
    this.store.select('common', 'turn', 'specialtyQuery');

  readUser = (): Observable<any> =>
    this.rest
      .get<SecurityUserLoginModel>({
        url: `${environment.endpoints.auth}/who-am-i`,
      })
      .pipe(
        tap((user) =>
          this.store.dispatch(adminUserActions.setResultAction(user))
        )
      );

  readTurns = (params: {
    patient?: string;
    doctor?: string;
    specialty?: string;
  }) =>
    this.rest
      .get<CommonTurnViewModel[]>({
        url: `${environment.endpoints.common}/turn`,
        params,
      })
      .pipe(
        tap((result) => {
          result.forEach((turn) => {
            turn.ageLabel = Utils.transformAge(turn.patientAge);
          });
          this.store.dispatch(commonTurnActions.setResultAction({ result }));
        })
      );

  readSubCatalogs = (): Observable<AdminCatalogModel[]>[] =>
    ['doc_type', 'gender', 'mar_status', 'spe', 'turn_status'].map((code) =>
      this.catalogService.readSubCatalogs(code, true)
    );
}
